import { useState } from 'react';
import { toast } from 'sonner';
import { useCart, apiErrorMessage } from '@/contexts/CartContext';

/**
 * سطر تركيبة واحدة في السلة: هل هي موجودة؟ وكم كميتها؟ + زيادة/تقليل/إضافة.
 * التقليل من 1 بيشيل المنتج من السلة.
 */
export const useCartLine = (variantId) => {
  const { findCartItem, addToCart, updateQuantity, removeItem } = useCart();
  const [busy, setBusy] = useState(false);
  const item = variantId ? findCartItem(variantId) : null;
  const quantity = item?.quantity ?? 0;

  const run = async (action, fallbackMessage) => {
    setBusy(true);
    try {
      await action();
      return true;
    } catch (error) {
      toast.error(apiErrorMessage(error, fallbackMessage));
      return false;
    } finally {
      setBusy(false);
    }
  };

  return {
    item,
    quantity,
    inCart: quantity > 0,
    busy,
    canIncrement: quantity < 99,
    add: (qty = 1) => run(() => addToCart(variantId, qty), 'فشلت إضافة المنتج'),
    increment: () => run(() => updateQuantity(item.id, quantity + 1), 'تعذر تحديث الكمية'),
    decrement: () =>
      run(() => (quantity <= 1 ? removeItem(item.id) : updateQuantity(item.id, quantity - 1)), 'تعذر تحديث الكمية'),
  };
};
